<template>
  <title>{{this.title}}</title>

  <router-view></router-view>

  
</template>

<script>
import http from "./common/http.js"
export default {
  name: 'App',
  data(){
    return{
      title:'',
      titleKey:{key:'WEBSITE_LABEL'}
    }
  },
  created(){  
    // this.getTitle()
  },  
  methods: {
    getTitle(){
      http('get',"/website/get_config",this.titleKey).then(res => {         
        this.title = res.data.value 
      })

    }
  }
  
}

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () { 
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}
</script>

<style>
#app {
  font-size: 14px;
  color: #333;
}
body{
  margin:0;
  box-sizing:border-box;
}
*{
  box-sizing:border-box;

}
</style>
